// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.season-page {
    padding: 20px;
}

.season-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.notes-section h2 {
    margin-bottom: 15px;
}

.note-card {
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.25);
    padding: 12px;
    border-radius: 10px;
    margin-bottom: 12px;
}

.note-date {
    font-size: 12px;
    opacity: 0.7;
    margin-bottom: 4px;
}

.note-content {
    font-size: 14px;
}

.note-content.active {
    font-weight: bold;
    color: #6fb8af;
}

/* Drawer */
.drawer-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.4);
    display: flex;
    justify-content: flex-end;
    z-index: 1000;
}

.drawer {
    width: 350px;
    height: 100%;
    background: var(--card-bg);
    padding: 20px;
    box-shadow: -4px 0 12px rgba(0,0,0,0.2);
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.drawer-actions {
    display: flex;
    gap: 10px;
    margin-top: auto;
}

/* Textarea + compteur */
.bio-edit-container {
    position: relative;
}

.bio-textarea {
    width: 100%;
    min-height: 120px;
    padding: 12px;
    padding-bottom: 32px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.35);
    color: var(--text-color);
    resize: none;
    outline: none;
    transition: 0.25s ease;
}

.bio-textarea:focus {
    border-color: var(--accent-color);
    box-shadow: 0 0 8px rgba(52, 152, 219, 0.4);
}

.bio-counter {
    position: absolute;
    bottom: 8px;
    right: 12px;
    font-size: 12px;
    opacity: 0.8;
    background: rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(6px);
    padding: 3px 6px;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.25);
    pointer-events: none;
}

.bio-counter.warning {
    color: #e74c3c;
    border-color: rgba(231, 76, 60, 0.4);
}

/* Animation */
.animate-bio {
    animation: bioFadeIn 0.35s ease forwards;
}

@keyframes bioFadeIn {
    0% {
        opacity: 0;
        transform: translateY(10px) scale(0.98);
    }
    100% {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

/* Bouton glass */
.edit-glass-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 10px 18px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.25);
    color: var(--text-color);
    font-size: 14px;
    cursor: pointer;
    transition: 0.25s ease;
}

.edit-glass-btn:hover {
    background: rgba(255, 255, 255, 0.25);
    border-color: rgba(255, 255, 255, 0.45);
    transform: translateY(-2px);
}

/* SEMIS */
.semis-section h2 {
    margin-top: 30px;
    margin-bottom: 10px;
}

.semis-card {
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.25);
    padding: 15px;
    border-radius: 10px;
    margin-bottom: 12px;
    line-height: 1.5;
    position: relative; /* needed to position the top-right icon */
}

.semis-card.cancelled {
    opacity: 0.55;
    filter: grayscale(0.25);
}

.semis-card.cancelled p {
    text-decoration: line-through;
}

.cancelled-badge {
    background: rgba(255,0,0,0.15);
    color: #ffdddd;
    border: 1px solid rgba(255,0,0,0.35);
    padding: 6px 8px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 13px;
}

/* Top-right cancel/reactivate icon button */
.cancel-icon-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 16px;
    padding: 6px;
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: 0.15s ease;
    color: rgba(255,255,255,0.85);
}

.cancel-icon-btn.cancel i,
.cancel-icon-btn.cancel .fa-times {
    color: #ff6b6b;
}

.cancel-icon-btn.reactivate i,
.cancel-icon-btn.reactivate .fa-undo {
    color: #8fd19e;
}

.cancel-icon-btn:hover {
    transform: scale(1.05);
    filter: brightness(1.1);
}

.cancel-icon-btn:focus { outline: none; box-shadow: 0 0 0 3px rgba(52,152,219,0.12); }

/* Large right-side label for cancelled semis */
.cancelled-side-label {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background: linear-gradient(90deg, rgba(255,0,0,0.06), rgba(255,0,0,0.02));
    border: 1px solid rgba(255,0,0,0.12);
    color: var(--text-color, #fff);
    padding: 12px 16px;
    border-radius: 10px;
    font-weight: 800;
    font-size: 18px;
    text-transform: uppercase;
    letter-spacing: 1px;
    opacity: 0.95;
    pointer-events: none; /* non-interactive */
    box-shadow: 0 6px 18px rgba(0,0,0,0.25);
}

/* Slightly smaller on small screens */
@media (max-width: 700px) {
    .cancelled-side-label {
        font-size: 14px;
        padding: 8px 10px;
        right: 8px;
    }
}

/* PHOTOS */
.photos-section h2 {
    margin-top: 30px;
    margin-bottom: 10px;
}

.photos-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 12px;
}

.photo-item {
    width: 100%;
    height: 120px;
    object-fit: cover;
    border-radius: 10px;
    cursor: pointer;
    border: 1px solid rgba(255, 255, 255, 0.25);
    transition: transform 0.2s ease;
}

.photo-item:hover {
    transform: scale(1.03);
}

.drawer-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.drawer-field label {
    font-size: 14px;
    opacity: 0.8;
}

.drawer-field input,
.drawer-field textarea {
    width: 100%;
    padding: 10px;
    border-radius: 8px;
    border: 1px solid rgba(255,255,255,0.3);
    background: rgba(255,255,255,0.15);
    color: var(--text-color);
    outline: none;
}

.drawer-field textarea {
    min-height: 80px;
    resize: none;
}

.season-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
}

.season-header-actions {
    display: flex;
    gap: 10px;
}

.edit-semis-icon {
    cursor: pointer;
    margin-left: 8px;
    font-size: 16px;
    opacity: 0.7;
    transition: 0.2s;
}

.edit-semis-icon:hover {
    opacity: 1;
    transform: scale(1.1);
}

/* Overlay */
.photo-preview-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.75);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
}

/* Container */
.photo-preview-container {
    position: relative;
    max-width: 90%;
    max-height: 90%;
}

/* Image agrandie */
.photo-preview-img {
    width: 100%;
    height: auto;
    max-height: 90vh;
    border-radius: 12px;
    box-shadow: 0 0 20px rgba(0,0,0,0.5);
}

/* Bouton fermer */
.photo-preview-close {
    position: absolute;
    top: -10px;
    right: -10px;
    background: rgba(255,255,255,0.9);
    border: none;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    cursor: pointer;
    font-size: 18px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.2s;
}

.photo-preview-close:hover {
    background: white;
    transform: scale(1.1);
}

.note-card {
    background: rgba(255,255,255,0.15);
    border: 1px solid rgba(255,255,255,0.25);
    padding: 12px;
    border-radius: 10px;
    margin-bottom: 12px;
    transition: 0.2s;
}

/* Note importante */
.important-note {
    border: 1px solid #6fb8af;
    background: rgba(111, 184, 175, 0.15);
}

/* Header */
.note-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

/* Icône étoile */
.note-important-icon {
    cursor: pointer;
    font-size: 12px;
    opacity: 0.5;
    transition: 0.2s;
}

.note-important-icon:hover {
    opacity: 1;
    transform: scale(1.1);
}

.note-important-icon.active {
    opacity: 1;
    color: #ffcc00;
}

/*ICI LES TAGS*/

.note-tags {
    display: flex;
    gap: 6px;
    margin: 6px 0 8px 0;
    flex-wrap: wrap;
}


.tag-badge {
    padding: 4px 8px;
    border-radius: 6px;
    font-size: 12px;
    background: rgba(255,255,255,0.15);
    border: 1px solid rgba(255,255,255,0.25);
}

.tag-pill {
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 500;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: rgba(255,255,255,0.15);
    border: 1px solid rgba(255,255,255,0.25);
    backdrop-filter: blur(6px);
}

/* Couleurs */
.tag-meteo { background: rgba(255, 200, 0, 0.25); border-color: #ffcc00; }
.tag-arrosage { background: rgba(0, 150, 255, 0.25); border-color: #0096ff; }
.tag-parasites { background: rgba(255, 0, 0, 0.25); border-color: #ff4444; }
.tag-croissance { background: rgba(0, 200, 0, 0.25); border-color: #00cc44; }
.tag-recolte { background: rgba(255, 100, 0, 0.25); border-color: #ff6600; }
.tag-plantation {
    background: rgba(150, 100, 50, 0.25); /* marron clair terre */
    border-color: #8B5A2B;                /* brun naturel */
}



/* Sélecteur */
.tags-selector {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
}

.tag-item {
    padding: 6px 10px;
    border-radius: 6px;
    cursor: pointer;
    background: rgba(255,255,255,0.1);
    border: 1px solid rgba(255,255,255,0.2);
    transition: 0.2s;
}

.tag-item.selected {
    background: rgba(255,255,255,0.3);
    border-color: white;
}

.archived-banner {
    background: rgba(255, 0, 0, 0.15);
    border: 1px solid #ff0000;
    padding: 12px;
    border-radius: 8px;
    margin-bottom: 20px;
    font-weight: 600;
}

.disabled-btn {
    opacity: 0.4;
    pointer-events: none;
}

button:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

.note-important-icon.disabled {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
}

.edit-semis-icon.disabled {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
}

.photos-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 12px;
}

/* Nouveau conteneur pour gérer la date */
.photo-wrapper {
    position: relative;
    transition: transform 0.2s ease;
}
.photo-wrapper:hover { transform: scale(1.03); }
/* Ton style existant, inchangé */
.photo-item {
    width: 100%;
    height: 120px;
    object-fit: cover;
    border-radius: 10px;
    cursor: pointer;
    border: 1px solid rgba(255, 255, 255, 0.25);
    transition: transform 0.2s ease;
}

.photo-item:hover {
    transform: scale(1.03);
}

/* La date sur la photo */
.photo-date {
    position: absolute;
    bottom: 6px;
    right: 6px;
    background: rgba(0, 0, 0, 0.55);
    color: white;
    padding: 2px 6px;
    font-size: 12px;
    border-radius: 4px;
    pointer-events: none; /* important : ne bloque pas le clic */
}
`, "",{"version":3,"sources":["webpack://./src/styles/SeasonPage.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;IAC1B,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA,WAAW;AACX;IACI,eAAe;IACf,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,0BAA0B;IAC1B,aAAa;IACb,uCAAuC;IACvC,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA,wBAAwB;AACxB;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,qCAAqC;IACrC,0BAA0B;IAC1B,2CAA2C;IAC3C,wBAAwB;IACxB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,eAAe;IACf,YAAY;IACZ,+BAA+B;IAC/B,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,2CAA2C;IAC3C,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,oCAAoC;AACxC;;AAEA,cAAc;AACd;IACI,wCAAwC;AAC5C;;AAEA;IACI;QACI,UAAU;QACV,uCAAuC;IAC3C;IACA;QACI,UAAU;QACV,iCAAiC;IACrC;AACJ;;AAEA,iBAAiB;AACjB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,qCAAqC;IACrC,2BAA2B;IAC3B,2CAA2C;IAC3C,wBAAwB;IACxB,eAAe;IACf,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,qCAAqC;IACrC,uCAAuC;IACvC,2BAA2B;AAC/B;;AAEA,UAAU;AACV;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;IAC1B,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB,EAAE,0CAA0C;AAClE;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;IAC9B,cAAc;IACd,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA,4CAA4C;AAC5C;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA,yBAAyB,aAAa,EAAE,2CAA2C,EAAE;;AAErF,+CAA+C;AAC/C;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,0EAA0E;IAC1E,oCAAoC;IACpC,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,oBAAoB,EAAE,oBAAoB;IAC1C,uCAAuC;AAC3C;;AAEA,sCAAsC;AACtC;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,UAAU;IACd;AACJ;;AAEA,WAAW;AACX;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,2CAA2C;IAC3C,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,uCAAuC;IACvC,kCAAkC;IAClC,wBAAwB;IACxB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,qBAAqB;AACzB;;AAEA,YAAY;AACZ;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,4BAA4B;IAC5B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA,cAAc;AACd;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA,mBAAmB;AACnB;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;IACnB,oCAAoC;AACxC;;AAEA,kBAAkB;AAClB;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,iCAAiC;IACjC,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,yBAAyB;IACzB,qCAAqC;AACzC;;AAEA,WAAW;AACX;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA,eAAe;;AAEf;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,eAAe;AACnB;;;AAGA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,kCAAkC;IAClC,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kCAAkC;IAClC,wCAAwC;IACxC,0BAA0B;AAC9B;;AAEA,aAAa;AACb,aAAa,mCAAmC,EAAE,qBAAqB,EAAE;AACzE,gBAAgB,mCAAmC,EAAE,qBAAqB,EAAE;AAC5E,iBAAiB,iCAAiC,EAAE,qBAAqB,EAAE;AAC3E,kBAAkB,iCAAiC,EAAE,qBAAqB,EAAE;AAC5E,eAAe,mCAAmC,EAAE,qBAAqB,EAAE;AAC3E;IACI,oCAAoC,EAAE,uBAAuB;IAC7D,qBAAqB,iBAAiB,iBAAiB;AAC3D;;;;AAIA,cAAc;AACd;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;IACjC,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA,yCAAyC;AACzC;IACI,kBAAkB;IAClB,+BAA+B;AACnC;AACA,uBAAuB,sBAAsB,EAAE;AAC/C,iCAAiC;AACjC;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,2CAA2C;IAC3C,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,+BAA+B;IAC/B,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,oBAAoB,EAAE,sCAAsC;AAChE","sourcesContent":[".season-page {\r\n    padding: 20px;\r\n}\r\n\r\n.season-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.notes-section h2 {\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.note-card {\r\n    background: rgba(255, 255, 255, 0.15);\r\n    backdrop-filter: blur(8px);\r\n    border: 1px solid rgba(255, 255, 255, 0.25);\r\n    padding: 12px;\r\n    border-radius: 10px;\r\n    margin-bottom: 12px;\r\n}\r\n\r\n.note-date {\r\n    font-size: 12px;\r\n    opacity: 0.7;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.note-content {\r\n    font-size: 14px;\r\n}\r\n\r\n.note-content.active {\r\n    font-weight: bold;\r\n    color: #6fb8af;\r\n}\r\n\r\n/* Drawer */\r\n.drawer-overlay {\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(0,0,0,0.4);\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    z-index: 1000;\r\n}\r\n\r\n.drawer {\r\n    width: 350px;\r\n    height: 100%;\r\n    background: var(--card-bg);\r\n    padding: 20px;\r\n    box-shadow: -4px 0 12px rgba(0,0,0,0.2);\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 20px;\r\n}\r\n\r\n.drawer-actions {\r\n    display: flex;\r\n    gap: 10px;\r\n    margin-top: auto;\r\n}\r\n\r\n/* Textarea + compteur */\r\n.bio-edit-container {\r\n    position: relative;\r\n}\r\n\r\n.bio-textarea {\r\n    width: 100%;\r\n    min-height: 120px;\r\n    padding: 12px;\r\n    padding-bottom: 32px;\r\n    border-radius: 10px;\r\n    background: rgba(255, 255, 255, 0.15);\r\n    backdrop-filter: blur(8px);\r\n    border: 1px solid rgba(255, 255, 255, 0.35);\r\n    color: var(--text-color);\r\n    resize: none;\r\n    outline: none;\r\n    transition: 0.25s ease;\r\n}\r\n\r\n.bio-textarea:focus {\r\n    border-color: var(--accent-color);\r\n    box-shadow: 0 0 8px rgba(52, 152, 219, 0.4);\r\n}\r\n\r\n.bio-counter {\r\n    position: absolute;\r\n    bottom: 8px;\r\n    right: 12px;\r\n    font-size: 12px;\r\n    opacity: 0.8;\r\n    background: rgba(0, 0, 0, 0.15);\r\n    backdrop-filter: blur(6px);\r\n    padding: 3px 6px;\r\n    border-radius: 6px;\r\n    border: 1px solid rgba(255, 255, 255, 0.25);\r\n    pointer-events: none;\r\n}\r\n\r\n.bio-counter.warning {\r\n    color: #e74c3c;\r\n    border-color: rgba(231, 76, 60, 0.4);\r\n}\r\n\r\n/* Animation */\r\n.animate-bio {\r\n    animation: bioFadeIn 0.35s ease forwards;\r\n}\r\n\r\n@keyframes bioFadeIn {\r\n    0% {\r\n        opacity: 0;\r\n        transform: translateY(10px) scale(0.98);\r\n    }\r\n    100% {\r\n        opacity: 1;\r\n        transform: translateY(0) scale(1);\r\n    }\r\n}\r\n\r\n/* Bouton glass */\r\n.edit-glass-btn {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    padding: 10px 18px;\r\n    border-radius: 10px;\r\n    background: rgba(255, 255, 255, 0.15);\r\n    backdrop-filter: blur(10px);\r\n    border: 1px solid rgba(255, 255, 255, 0.25);\r\n    color: var(--text-color);\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    transition: 0.25s ease;\r\n}\r\n\r\n.edit-glass-btn:hover {\r\n    background: rgba(255, 255, 255, 0.25);\r\n    border-color: rgba(255, 255, 255, 0.45);\r\n    transform: translateY(-2px);\r\n}\r\n\r\n/* SEMIS */\r\n.semis-section h2 {\r\n    margin-top: 30px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.semis-card {\r\n    background: rgba(255, 255, 255, 0.15);\r\n    backdrop-filter: blur(8px);\r\n    border: 1px solid rgba(255, 255, 255, 0.25);\r\n    padding: 15px;\r\n    border-radius: 10px;\r\n    margin-bottom: 12px;\r\n    line-height: 1.5;\r\n    position: relative; /* needed to position the top-right icon */\r\n}\r\n\r\n.semis-card.cancelled {\r\n    opacity: 0.55;\r\n    filter: grayscale(0.25);\r\n}\r\n\r\n.semis-card.cancelled p {\r\n    text-decoration: line-through;\r\n}\r\n\r\n.cancelled-badge {\r\n    background: rgba(255,0,0,0.15);\r\n    color: #ffdddd;\r\n    border: 1px solid rgba(255,0,0,0.35);\r\n    padding: 6px 8px;\r\n    border-radius: 8px;\r\n    font-weight: 600;\r\n    font-size: 13px;\r\n}\r\n\r\n/* Top-right cancel/reactivate icon button */\r\n.cancel-icon-btn {\r\n    position: absolute;\r\n    top: 8px;\r\n    right: 8px;\r\n    background: transparent;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n    padding: 6px;\r\n    border-radius: 6px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    transition: 0.15s ease;\r\n    color: rgba(255,255,255,0.85);\r\n}\r\n\r\n.cancel-icon-btn.cancel i,\r\n.cancel-icon-btn.cancel .fa-times {\r\n    color: #ff6b6b;\r\n}\r\n\r\n.cancel-icon-btn.reactivate i,\r\n.cancel-icon-btn.reactivate .fa-undo {\r\n    color: #8fd19e;\r\n}\r\n\r\n.cancel-icon-btn:hover {\r\n    transform: scale(1.05);\r\n    filter: brightness(1.1);\r\n}\r\n\r\n.cancel-icon-btn:focus { outline: none; box-shadow: 0 0 0 3px rgba(52,152,219,0.12); }\r\n\r\n/* Large right-side label for cancelled semis */\r\n.cancelled-side-label {\r\n    position: absolute;\r\n    right: 12px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    background: linear-gradient(90deg, rgba(255,0,0,0.06), rgba(255,0,0,0.02));\r\n    border: 1px solid rgba(255,0,0,0.12);\r\n    color: var(--text-color, #fff);\r\n    padding: 12px 16px;\r\n    border-radius: 10px;\r\n    font-weight: 800;\r\n    font-size: 18px;\r\n    text-transform: uppercase;\r\n    letter-spacing: 1px;\r\n    opacity: 0.95;\r\n    pointer-events: none; /* non-interactive */\r\n    box-shadow: 0 6px 18px rgba(0,0,0,0.25);\r\n}\r\n\r\n/* Slightly smaller on small screens */\r\n@media (max-width: 700px) {\r\n    .cancelled-side-label {\r\n        font-size: 14px;\r\n        padding: 8px 10px;\r\n        right: 8px;\r\n    }\r\n}\r\n\r\n/* PHOTOS */\r\n.photos-section h2 {\r\n    margin-top: 30px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.photos-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\r\n    gap: 12px;\r\n}\r\n\r\n.photo-item {\r\n    width: 100%;\r\n    height: 120px;\r\n    object-fit: cover;\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n    border: 1px solid rgba(255, 255, 255, 0.25);\r\n    transition: transform 0.2s ease;\r\n}\r\n\r\n.photo-item:hover {\r\n    transform: scale(1.03);\r\n}\r\n\r\n.drawer-field {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 6px;\r\n}\r\n\r\n.drawer-field label {\r\n    font-size: 14px;\r\n    opacity: 0.8;\r\n}\r\n\r\n.drawer-field input,\r\n.drawer-field textarea {\r\n    width: 100%;\r\n    padding: 10px;\r\n    border-radius: 8px;\r\n    border: 1px solid rgba(255,255,255,0.3);\r\n    background: rgba(255,255,255,0.15);\r\n    color: var(--text-color);\r\n    outline: none;\r\n}\r\n\r\n.drawer-field textarea {\r\n    min-height: 80px;\r\n    resize: none;\r\n}\r\n\r\n.season-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.season-header-actions {\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.edit-semis-icon {\r\n    cursor: pointer;\r\n    margin-left: 8px;\r\n    font-size: 16px;\r\n    opacity: 0.7;\r\n    transition: 0.2s;\r\n}\r\n\r\n.edit-semis-icon:hover {\r\n    opacity: 1;\r\n    transform: scale(1.1);\r\n}\r\n\r\n/* Overlay */\r\n.photo-preview-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background: rgba(0,0,0,0.75);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    z-index: 2000;\r\n}\r\n\r\n/* Container */\r\n.photo-preview-container {\r\n    position: relative;\r\n    max-width: 90%;\r\n    max-height: 90%;\r\n}\r\n\r\n/* Image agrandie */\r\n.photo-preview-img {\r\n    width: 100%;\r\n    height: auto;\r\n    max-height: 90vh;\r\n    border-radius: 12px;\r\n    box-shadow: 0 0 20px rgba(0,0,0,0.5);\r\n}\r\n\r\n/* Bouton fermer */\r\n.photo-preview-close {\r\n    position: absolute;\r\n    top: -10px;\r\n    right: -10px;\r\n    background: rgba(255,255,255,0.9);\r\n    border: none;\r\n    border-radius: 50%;\r\n    width: 32px;\r\n    height: 32px;\r\n    cursor: pointer;\r\n    font-size: 18px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    transition: 0.2s;\r\n}\r\n\r\n.photo-preview-close:hover {\r\n    background: white;\r\n    transform: scale(1.1);\r\n}\r\n\r\n.note-card {\r\n    background: rgba(255,255,255,0.15);\r\n    border: 1px solid rgba(255,255,255,0.25);\r\n    padding: 12px;\r\n    border-radius: 10px;\r\n    margin-bottom: 12px;\r\n    transition: 0.2s;\r\n}\r\n\r\n/* Note importante */\r\n.important-note {\r\n    border: 1px solid #6fb8af;\r\n    background: rgba(111, 184, 175, 0.15);\r\n}\r\n\r\n/* Header */\r\n.note-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n/* Icône étoile */\r\n.note-important-icon {\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n    opacity: 0.5;\r\n    transition: 0.2s;\r\n}\r\n\r\n.note-important-icon:hover {\r\n    opacity: 1;\r\n    transform: scale(1.1);\r\n}\r\n\r\n.note-important-icon.active {\r\n    opacity: 1;\r\n    color: #ffcc00;\r\n}\r\n\r\n/*ICI LES TAGS*/\r\n\r\n.note-tags {\r\n    display: flex;\r\n    gap: 6px;\r\n    margin: 6px 0 8px 0;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n\r\n.tag-badge {\r\n    padding: 4px 8px;\r\n    border-radius: 6px;\r\n    font-size: 12px;\r\n    background: rgba(255,255,255,0.15);\r\n    border: 1px solid rgba(255,255,255,0.25);\r\n}\r\n\r\n.tag-pill {\r\n    padding: 6px 12px;\r\n    border-radius: 20px;\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    background: rgba(255,255,255,0.15);\r\n    border: 1px solid rgba(255,255,255,0.25);\r\n    backdrop-filter: blur(6px);\r\n}\r\n\r\n/* Couleurs */\r\n.tag-meteo { background: rgba(255, 200, 0, 0.25); border-color: #ffcc00; }\r\n.tag-arrosage { background: rgba(0, 150, 255, 0.25); border-color: #0096ff; }\r\n.tag-parasites { background: rgba(255, 0, 0, 0.25); border-color: #ff4444; }\r\n.tag-croissance { background: rgba(0, 200, 0, 0.25); border-color: #00cc44; }\r\n.tag-recolte { background: rgba(255, 100, 0, 0.25); border-color: #ff6600; }\r\n.tag-plantation {\r\n    background: rgba(150, 100, 50, 0.25); /* marron clair terre */\r\n    border-color: #8B5A2B;                /* brun naturel */\r\n}\r\n\r\n\r\n\r\n/* Sélecteur */\r\n.tags-selector {\r\n    display: flex;\r\n    gap: 8px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.tag-item {\r\n    padding: 6px 10px;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    background: rgba(255,255,255,0.1);\r\n    border: 1px solid rgba(255,255,255,0.2);\r\n    transition: 0.2s;\r\n}\r\n\r\n.tag-item.selected {\r\n    background: rgba(255,255,255,0.3);\r\n    border-color: white;\r\n}\r\n\r\n.archived-banner {\r\n    background: rgba(255, 0, 0, 0.15);\r\n    border: 1px solid #ff0000;\r\n    padding: 12px;\r\n    border-radius: 8px;\r\n    margin-bottom: 20px;\r\n    font-weight: 600;\r\n}\r\n\r\n.disabled-btn {\r\n    opacity: 0.4;\r\n    pointer-events: none;\r\n}\r\n\r\nbutton:disabled {\r\n    opacity: 0.4;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.note-important-icon.disabled {\r\n    opacity: 0.4;\r\n    cursor: not-allowed;\r\n    pointer-events: none;\r\n}\r\n\r\n.edit-semis-icon.disabled {\r\n    opacity: 0.4;\r\n    cursor: not-allowed;\r\n    pointer-events: none;\r\n}\r\n\r\n.photos-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\r\n    gap: 12px;\r\n}\r\n\r\n/* Nouveau conteneur pour gérer la date */\r\n.photo-wrapper {\r\n    position: relative;\r\n    transition: transform 0.2s ease;\r\n}\r\n.photo-wrapper:hover { transform: scale(1.03); }\r\n/* Ton style existant, inchangé */\r\n.photo-item {\r\n    width: 100%;\r\n    height: 120px;\r\n    object-fit: cover;\r\n    border-radius: 10px;\r\n    cursor: pointer;\r\n    border: 1px solid rgba(255, 255, 255, 0.25);\r\n    transition: transform 0.2s ease;\r\n}\r\n\r\n.photo-item:hover {\r\n    transform: scale(1.03);\r\n}\r\n\r\n/* La date sur la photo */\r\n.photo-date {\r\n    position: absolute;\r\n    bottom: 6px;\r\n    right: 6px;\r\n    background: rgba(0, 0, 0, 0.55);\r\n    color: white;\r\n    padding: 2px 6px;\r\n    font-size: 12px;\r\n    border-radius: 4px;\r\n    pointer-events: none; /* important : ne bloque pas le clic */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
